import { Search } from "lucide-react";
import { useEffect, useRef } from "react";

/**
 * Plain text field for list-column filter popovers.
 *
 * cmdk's CommandInput treats keystrokes as command-list typeahead, which
 * selects the highlighted item and can dismiss the popover. This input
 * stops that so users can click and type.
 */
export function FilterSearchInput({
  value,
  onValueChange,
  placeholder,
  focusOnMount = false,
}: {
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
  focusOnMount?: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focusOnMount) {
      inputRef.current?.focus();
    }
  }, [focusOnMount]);

  return (
    <div className="flex h-9 items-center gap-2 border-b px-3">
      <Search className="size-4 shrink-0 opacity-50" />
      <input
        ref={inputRef}
        data-slot="filter-search"
        autoComplete="off"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        onKeyDown={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
        className="placeholder:text-muted-foreground flex h-10 w-full bg-transparent py-3 text-xs outline-hidden"
        aria-label={placeholder}
      />
    </div>
  );
}
